export const generatedSidecarWorkOrderPacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-sidecar-execution-work-orders",
  "operatingRule": "External science workers must produce hash-backed JSON artifacts matching these work orders before trajectory, event-window, or optimization claims can promote.",
  "validationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "workOrderCount": 5,
  "blockedWorkOrderCount": 5,
  "workOrders": [
    {
      "id": "work-order-spice-gf-event-window-v1",
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "executionState": "blocked-worker-not-installed",
      "claimState": "work-order-only-not-runtime-evidence",
      "priorityScenarios": [
        "hybrid",
        "mercury-orbit",
        "moon-first"
      ],
      "sourceRefs": [
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
          "recordHash": "fnv1a32-97d74c96",
          "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
          "uncertaintyMode": "Kernel coverage plus geometric tolerance."
        }
      ],
      "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
      "implementationScaffold": {
        "state": "runtime-worker-source-present",
        "pathChecks": [
          {
            "path": "sidecars/spice_gf/run_spice_gf.py",
            "exists": true
          },
          {
            "path": "sidecars/spice_gf/requirements.txt",
            "exists": true
          }
        ],
        "promotionBoundary": "Source scaffold availability is implementation readiness only. It is not runtime evidence and cannot promote a science claim."
      },
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "kernelSet",
        "kernelHashes",
        "timeScale",
        "gfConstraint",
        "eventWindows",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "limitations",
        "validationStatus"
      ],
      "acceptanceCriteria": [
        "The generated JSON artifact must validate against every required field in the contract.",
        "artifactState must be runtime-generated.",
        "validationStatus must be passed.",
        "sourceIds must match the contract source ids.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand must be populated.",
        "Generated windows must include kernel hashes, constraints, and event-window units."
      ],
      "blockedBy": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: kernelSet",
        "Missing required field: kernelHashes",
        "Missing required field: timeScale",
        "Missing required field: gfConstraint",
        "Missing required field: eventWindows",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Artifact is not runtime-generated.",
        "Validation status is not passed."
      ],
      "nextAction": "SPICE event windows can promote only when kernel hashes, time scale, GF constraints, generated windows, and checksum evidence are attached.",
      "promotionRule": "This work order is not evidence. Only its generated sidecar JSON output can enter the validation gate.",
      "workOrderHash": "sha256-28129dc4f5b602e71d08f8d395f99a34f947b41c576c5b070c8a2c010456ce42"
    },
    {
      "id": "work-order-orekit-propagation-v1",
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "executionState": "blocked-worker-not-installed",
      "claimState": "work-order-only-not-runtime-evidence",
      "priorityScenarios": [
        "hybrid",
        "moon-first",
        "asteroid-first"
      ],
      "sourceRefs": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "url": "https://www.orekit.org/",
          "recordHash": "fnv1a32-88a8d672",
          "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
          "uncertaintyMode": "Model configuration and independent comparison residuals."
        }
      ],
      "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
      "implementationScaffold": {
        "state": "source-scaffold-present-runtime-not-built",
        "pathChecks": [
          {
            "path": "sidecars/orekit/src/main/java/com/sovereignsystems/interstellar/orekit/OrekitSidecar.java",
            "exists": true
          },
          {
            "path": "sidecars/orekit/build.gradle.kts",
            "exists": true
          },
          {
            "path": "artifacts/sidecars/orekit/hybrid-lunar-transfer.propagation.json",
            "exists": true
          }
        ],
        "promotionBoundary": "Source scaffold availability is implementation readiness only. It is not runtime evidence and cannot promote a science claim."
      },
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "dataContext",
        "frames",
        "timeScale",
        "forceModel",
        "events",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceCriteria": [
        "The generated JSON artifact must validate against every required field in the contract.",
        "artifactState must be runtime-generated.",
        "validationStatus must be passed.",
        "sourceIds must match the contract source ids.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand must be populated.",
        "independentComparison.status must be passed with residual bounds."
      ],
      "blockedBy": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: dataContext",
        "Missing required field: frames",
        "Missing required field: timeScale",
        "Missing required field: forceModel",
        "Missing required field: events",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "promotionRule": "This work order is not evidence. Only its generated sidecar JSON output can enter the validation gate.",
      "workOrderHash": "sha256-69e531fee46ffac8b1b6865c5bc3cc5248c7b3d18f193615a03cd44aedd404b7"
    },
    {
      "id": "work-order-gmat-transfer-v1",
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "executionState": "blocked-worker-not-installed",
      "claimState": "work-order-only-not-runtime-evidence",
      "priorityScenarios": [
        "hybrid",
        "moon-first",
        "mercury-orbit"
      ],
      "sourceRefs": [
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "url": "https://software.nasa.gov/software/GSC-17177-1",
          "recordHash": "fnv1a32-3743e565",
          "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
          "uncertaintyMode": "Constraint residuals and cross-tool comparison."
        }
      ],
      "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "implementationScaffold": {
        "state": "source-scaffold-present-runtime-not-built",
        "pathChecks": [
          {
            "path": "sidecars/gmat/run_gmat_transfer.py",
            "exists": true
          },
          {
            "path": "artifacts/sidecars/gmat/hybrid-transfer.script-manifest.example.json",
            "exists": true
          }
        ],
        "promotionBoundary": "Source scaffold availability is implementation readiness only. It is not runtime evidence and cannot promote a science claim."
      },
      "requiredFields": [
        "gmatVersion",
        "runAt",
        "scenarioId",
        "scriptHash",
        "epoch",
        "forceModel",
        "optimizer",
        "trajectorySummary",
        "constraintSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceCriteria": [
        "The generated JSON artifact must validate against every required field in the contract.",
        "artifactState must be runtime-generated.",
        "validationStatus must be passed.",
        "sourceIds must match the contract source ids.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand must be populated.",
        "independentComparison.status must be passed with residual bounds."
      ],
      "blockedBy": [
        "Missing required field: gmatVersion",
        "Missing required field: runAt",
        "Missing required field: scriptHash",
        "Missing required field: epoch",
        "Missing required field: forceModel",
        "Missing required field: optimizer",
        "Missing required field: trajectorySummary",
        "Missing required field: constraintSummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "promotionRule": "This work order is not evidence. Only its generated sidecar JSON output can enter the validation gate.",
      "workOrderHash": "sha256-fe29e92d043ca958978f5f4495f54e42bb1b84cdf0965ca5db25f5e77b1f0b8d"
    },
    {
      "id": "work-order-tudat-transfer-v1",
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "executionState": "blocked-worker-not-installed",
      "claimState": "work-order-only-not-runtime-evidence",
      "priorityScenarios": [
        "asteroid-first",
        "hybrid"
      ],
      "sourceRefs": [
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "url": "https://docs.tudat.space/en/latest/",
          "recordHash": "fnv1a32-c238f1d2",
          "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
          "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds."
        }
      ],
      "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "implementationScaffold": {
        "state": "source-scaffold-present-runtime-not-built",
        "pathChecks": [
          {
            "path": "sidecars/tudat/run_tudat_transfer.py",
            "exists": true
          },
          {
            "path": "sidecars/tudat/requirements.txt",
            "exists": true
          },
          {
            "path": "artifacts/sidecars/tudat/asteroid-transfer.settings.example.json",
            "exists": true
          }
        ],
        "promotionBoundary": "Source scaffold availability is implementation readiness only. It is not runtime evidence and cannot promote a science claim."
      },
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "bodySettings",
        "integrator",
        "propagatorSettings",
        "trajectorySummary",
        "residualSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceCriteria": [
        "The generated JSON artifact must validate against every required field in the contract.",
        "artifactState must be runtime-generated.",
        "validationStatus must be passed.",
        "sourceIds must match the contract source ids.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand must be populated.",
        "independentComparison.status must be passed with residual bounds."
      ],
      "blockedBy": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: bodySettings",
        "Missing required field: integrator",
        "Missing required field: propagatorSettings",
        "Missing required field: trajectorySummary",
        "Missing required field: residualSummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "promotionRule": "This work order is not evidence. Only its generated sidecar JSON output can enter the validation gate.",
      "workOrderHash": "sha256-762279e25442533a1eb05a89ea533c13c672334e6f1bc44279885dc56a2d8ff8"
    },
    {
      "id": "work-order-openmdao-dymos-optimization-v1",
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "executionState": "blocked-worker-not-installed",
      "claimState": "work-order-only-not-runtime-evidence",
      "priorityScenarios": [
        "hybrid",
        "moon-first"
      ],
      "sourceRefs": [
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "url": "https://openmdao.org/",
          "recordHash": "fnv1a32-9ef7d3cb",
          "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
          "uncertaintyMode": "Sensitivity and optimizer-convergence metadata."
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "url": "https://openmdao.github.io/dymos/",
          "recordHash": "fnv1a32-31dbd31c",
          "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
          "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals."
        }
      ],
      "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "implementationScaffold": {
        "state": "runtime-worker-source-present",
        "pathChecks": [
          {
            "path": "sidecars/openmdao_dymos/run_optimization.py",
            "exists": true
          },
          {
            "path": "sidecars/openmdao_dymos/requirements.txt",
            "exists": true
          },
          {
            "path": "artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json",
            "exists": true
          }
        ],
        "promotionBoundary": "Source scaffold availability is implementation readiness only. It is not runtime evidence and cannot promote a science claim."
      },
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "problemHash",
        "transcription",
        "optimizer",
        "objective",
        "constraints",
        "sensitivitySummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceCriteria": [
        "The generated JSON artifact must validate against every required field in the contract.",
        "artifactState must be runtime-generated.",
        "validationStatus must be passed.",
        "sourceIds must match the contract source ids.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand must be populated.",
        "independentComparison.status must be passed with residual bounds."
      ],
      "blockedBy": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: problemHash",
        "Missing required field: transcription",
        "Missing required field: optimizer",
        "Missing required field: objective",
        "Missing required field: constraints",
        "Missing required field: sensitivitySummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Optimization outputs can influence recommendations only when objective, constraints, sensitivities, and reproducible run artifacts are attached.",
      "promotionRule": "This work order is not evidence. Only its generated sidecar JSON output can enter the validation gate.",
      "workOrderHash": "sha256-1ce46385d38db2f60463bcece1fffd0384f58b63d8f7c30ca9c777ac046ece55"
    }
  ],
  "packetHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4"
}
;
